import { IconButton, Stack, Typography, useTheme } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { getDataTestId } from '@/utils/browser';

import { DrawerContent, DrawerHeader } from '..';
import { HeaderMobile } from '../../Header/HeaderMobile';
import { Icon } from '../../Icon/Icon';
import { DrawerProps } from './Drawer.interface';

import { DocumentDrawer } from './Drawer.styled';

export function Drawer({
  title,
  onClose,
  children,
  bgColor,
  headerBgColor,
  rightSlot,
  ...props
}: DrawerProps) {
  const theme = useTheme();

  return (
    <DocumentDrawer {...props} bgColor={bgColor?.(theme)}>
      <HeaderMobile
        bgColor={headerBgColor}
        leftSlot={
          <IconButton onClick={onClose}>
            <Icon
              name="close"
              color={(theme: Theme) => theme.palette.grey[700]}
            />
          </IconButton>
        }
        centerSlot={
          title ? (
            typeof title === 'string' ? (
              <Typography variant="body1Bold">{title}</Typography>
            ) : (
              title
            )
          ) : null
        }
        rightSlot={rightSlot}
      />
      <DrawerHeader>
        <Typography variant="h5">{title}</Typography>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {rightSlot}
          <IconButton
            {...getDataTestId(`drawer-close-button`)}
            onClick={onClose}
          >
            <Icon
              name="close"
              color={(theme: Theme) => theme.palette.grey[700]}
            />
          </IconButton>
        </Stack>
      </DrawerHeader>
      <DrawerContent>{children}</DrawerContent>
    </DocumentDrawer>
  );
}
